<div *ngIf="page_loaded">
    <div class="new-summary-section">
        <!-- <div class="each-new-summary-section">
            <p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_data['clients_by_summary']['total_clients']) }}</p>
            <p class="each-new-summary-section-label">Total Clients</p>
        </div>
        <div class="each-new-summary-section">
                  <p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_data['clients_by_summary']['increase_focus']) }}</p>
                  <p class="each-new-summary-section-label">Increase Focus</p>
              </div>
        <div class="each-new-summary-section">
                  <p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_data['clients_by_summary']['agi_clients']) }}</p>
                  <p class="each-new-summary-section-label">MAGI Clients</p>
              </div>
        <div class="each-new-summary-section">
            <p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_data['clients_by_summary']['afa_clients']) }}</p>
            <p class="each-new-summary-section-label">AFA Clients</p>
        </div> -->
        <div></div>
        <div class="each-new-summary-section">
            <div class="each-new-summary-section-switch">
                <mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_page_graphs" (change)="toggleGraphs()" ></mat-slide-toggle>
            </div>
            <p class="each-new-summary-section-label">Graphical Representation</p>
        </div>
    </div>
    <div class="optimize-charts-section" *ngIf="show_page_graphs">
      <ngx-slick-carousel
        class="carousel"
        #slickModal="slick-carousel"
        [config]="graphSlideConfig"
      >
        <div ngxSlickItem class="each-dashboard-graph-block">
          <div class="portfolio-inner-heading-section">
            <img
              src="assets/events.png"
              class="portfolio-section-icon"
            />
            <!-- <span>Trends - Existing Clients</span> -->
            <span>By Acquisition Year</span>
          </div>
          <div class="each-dashboard-graph-content">
            <div id="existing-clients-graph"></div>
          </div>
        </div>
        <!-- <div ngxSlickItem class="each-dashboard-graph-block">
          <div class="portfolio-inner-heading-section">
            <img
              src="assets/events.png"
              class="portfolio-section-icon"
            />
            <span>Clients by Recommendation</span>
          </div>
          <div class="each-dashboard-graph-content">
            <div id="recommendation-clients-graph"></div>
          </div>
        </div> -->
        <div ngxSlickItem class="each-dashboard-graph-block">
          <div class="portfolio-inner-heading-section">
            <img
              src="assets/events.png"
              class="portfolio-section-icon"
            />
            <span>Clients by AUM</span>
          </div>
          <div class="each-dashboard-graph-content">
            <div id="aum-graph"></div>
          </div>
        </div>
        <div ngxSlickItem class="each-dashboard-graph-block" *ngIf="recommendation_filter == 'Increase Focus'">
          <div class="portfolio-inner-heading-section">
            <img
              src="assets/events.png"
              class="portfolio-section-icon"
            />
            <span>Clients by Type</span>
          </div>
          <div class="each-dashboard-graph-content">
            <div id="clients-type-graph"></div>
          </div>
        </div>
        <div ngxSlickItem class="each-dashboard-graph-block">
          <div class="portfolio-inner-heading-section">
            <img
              src="assets/events.png"
              class="portfolio-section-icon"
            />
            <span>Clients by Products</span>
          </div>
          <div class="each-dashboard-graph-content">
            <div id="products-clients-graph"></div>
          </div>
        </div>
        <div ngxSlickItem class="each-dashboard-graph-block">
          <div class="portfolio-inner-heading-section">
            <img
              src="assets/events.png"
              class="portfolio-section-icon"
            />
            <span>Client by Age Group</span>
          </div>
          <div class="each-dashboard-graph-content">
            <div id="age-clients-graph"></div>
          </div>
        </div>
        <div ngxSlickItem class="each-dashboard-graph-block">
          <div class="portfolio-inner-heading-section">
            <img
              src="assets/events.png"
              class="portfolio-section-icon"
            />
            <span>Client by Assignment</span>
          </div>
          <div class="each-dashboard-graph-content">
            <div id="assignment-graph"></div>
          </div>
        </div>
        <!-- <div ngxSlickItem class="each-dashboard-graph-block">
            <div class="portfolio-inner-heading-section">
              <img
                src="assets/events.png"
                class="portfolio-section-icon"
              />
              <span>Client by Region</span>
            </div>
            <div class="each-dashboard-graph-content">
                <highcharts-chart
                [Highcharts]="Highcharts"
                [constructorType]="chartConstructor"
                [options]="chartOptions"
                [(update)]="updateFlag"
                [oneToOne]="true"
                style="width: 100%; height: 245px; display: block"
              >
              </highcharts-chart>
            </div>
          </div> -->
      </ngx-slick-carousel>
    </div>
    <div>
      <div class="portfolio-inner-heading-section">
        <img
          src="assets/interaction-summary.png"
          class="portfolio-section-icon"
        />
        <span>Clients Summary</span>
      </div>
      <div class="leads-table-section">
        <div class="new-table-heading-section">
          <div class="mb-2">
            <span class="new-filter-tag" *ngIf="existing_customer_year != ''">
                {{existing_customer_year}}
                <img src="assets/filter-tag-close.png" class="filter-close-icon" (click)="existing_customer_year = ''; existing_customer_type = ''; current_pagination_page = 1; getClientsData()"/>
              </span>

            <span class="new-filter-tag" *ngIf="product_id != ''">
              {{ product_name }}
              <img
                src="assets/filter-tag-close.png"
                class="filter-close-icon"
                (click)="
                  product_id = '';
                  product_name = '';
                  current_pagination_page = 1;
                  getClientsData()
                "
              />
            </span>
            <!-- <span class="new-filter-tag" *ngIf="recommendation_id != ''">
              {{ recommendation_id }}
              <img
                src="assets/filter-tag-close.png"
                class="filter-close-icon"
                (click)="
                  recommendation_id = '';
                  recommendation_id = '';
                  current_pagination_page = 1;
                  getClientsData()
                "
              />
            </span> -->
            <span class="new-filter-tag" *ngIf="aum_min_id != ''">
              {{ aum_min_id }} - {{ aum_max_id }}
              <img
                src="assets/filter-tag-close.png"
                class="filter-close-icon"
                (click)="
                  aum_min_id = '';
                  aum_max_id = '';
                  current_pagination_page = 1;
                  getClientsData()
                "
              />
            </span>
            <span class="new-filter-tag" *ngIf="clients_by_type_id != ''">
              {{ clients_by_type_name }}
              <img
                src="assets/filter-tag-close.png"
                class="filter-close-icon"
                (click)="
                  clients_by_type_id = '';
                  clients_by_type_name = '';
                  current_pagination_page = 1;
                  getClientsData()
                "
              />
            </span>
            <span class="new-filter-tag" *ngIf="age_group_id != ''">
              {{ age_group_name }}
              <img
                src="assets/filter-tag-close.png"
                class="filter-close-icon"
                (click)="
                  age_group_id = '';
                  age_group_name = '';
                  current_pagination_page = 1;
                  getClientsData()
                "
              />
            </span>
            <span class="new-filter-tag" *ngIf="assignment_id != ''">
              {{ assignment_name }}
              <img
                src="assets/filter-tag-close.png"
                class="filter-close-icon"
                (click)="
                  assignment_id = '';
                  assignment_name = '';
                  current_pagination_page = 1;
                  getClientsData()
                "
              />
            </span>
          </div>
          <ng-container *ngIf="page_type != 'Individual'">
            <button class="move-button" style="margin-right: 16px; position: relative; top: 6px;" (click)="moveToAssignAIAdvisorAssistant()" *ngIf="!user_details.is_book_optimized">Update Recommendation</button>
            <button class="move-button" style="margin-right: 16px; position: relative; top: 6px;" (click)="moveToDelagateMAGI()" *ngIf="!user_details.is_book_optimized && recommendation_id == 'Delegate MAGI'">Assign MAGI</button>
            <button class="move-button" style="margin-right: 16px; position: relative; top: 6px;" (click)="moveToDelagateAFA()" *ngIf="!user_details.is_book_optimized && recommendation_id == 'Delegate Junior Advisor'">Assign Junior Advisor</button>
          </ng-container>
          <ng-container *ngIf="page_type == 'Individual'">
            <button class="move-button" style="margin-right: 16px; position: relative; top: 6px;" (click)="moveToAssignAIAdvisorAssistant()">Update Recommendation</button>
            <button class="move-button" style="margin-right: 16px; position: relative; top: 6px;" (click)="moveToDelagateMAGI()" *ngIf="recommendation_id == 'Delegate MAGI'">Assign MAGI</button>
            <button class="move-button" style="margin-right: 16px; position: relative; top: 6px;" (click)="moveToDelagateAFA()" *ngIf="recommendation_id == 'Delegate Junior Advisor'">Assign Junior Advisor</button>
          </ng-container>
          <span style="visibility: hidden">Digital Channel Advisor</span>
          <div class="new-table-actions ml-4">
            <div
              class="each-action-section search-input-section"
              *ngIf="show_search"
            >
              <input
                type="text"
                placeholder="Search"
                class="search-input"
                [(ngModel)]="search_key"
                (input)="current_pagination_page = 1; getClientsData()"
              />
              <span
                class="search-input-close"
                (click)="
                  show_search = false;
                  search_key = '';
                  current_pagination_page = 1;
                  getClientsData()
                "
                >&times;</span
              >
            </div>
            <div
              class="each-action-section search-icon"
              *ngIf="!show_search"
              (click)="show_search = true"
            >
              <img src="assets/search.png" class="button-icon" />
              <span>Search</span>
            </div>
            <div class="each-action-section dynamic-columns-section">
              <img
                src="assets/column-filter.png"
                class="button-icon"
                (click)="show_toggle_columns = !show_toggle_columns"
              />
              <div class="dynamic-columns" *ngIf="show_toggle_columns">
                <div class="dynamic-column-heading-section">
                  <span>Add Columns</span>
                  <span
                    class="columns-close"
                    (click)="show_toggle_columns = false"
                    >&times;</span
                  >
                </div>
                <div class="dynamic-column-content">
                  <div
                    class="each-column-section"
                    *ngFor="let column of table_columns"
                  >
                    <mat-checkbox
                      [checked]="column.checked == true"
                      (change)="column.checked = !column.checked"
                      >{{ column.name }}</mat-checkbox
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- <button class="move-button" (click)="moveToSalesProcess()">Move</button> -->
          </div>
        </div>
        <!-- <div class="alphabets-filter-section">
              <p class="new-each-filter-alphabet" [ngClass]="{'new-filter-alphabet-selected': alphabet == selected_alphabet}" *ngFor="let alphabet of alphabets_array" (click)="current_pagination_page = 1; selected_alphabet=alphabet; getClientsData()" style="margin-bottom: 8px !important;">
                  {{alphabet}}
              </p>
              <p class="clear-filter-alphabet" (click)="current_pagination_page = 1; selected_alphabet=''; getClientsData()">
                  Clear
              </p>
              </div> -->
        <!-- <div class="new-table-section"> -->
        <div class="new-table-v2-overflow">
          <!-- <table class="new-table"> -->
          <table class="new-table-v2">
            <thead>
              <tr>
                <!-- <th>
                              <mat-checkbox [checked]="is_selected" (change)="selectAll($event)"></mat-checkbox>
                          </th> -->
                <!-- <th appColumnResizable> -->
                <th>
                  <ng-container *ngIf="page_type != 'Individual'">
                    <div class="record-selection-section" *ngIf="!user_details.is_book_optimized">
                      <mat-checkbox [checked]="is_selected" (change)="selectAll($event)"></mat-checkbox>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="page_type == 'Individual'">
                    <div class="record-selection-section">
                      <mat-checkbox [checked]="is_selected" (change)="selectAll($event)"></mat-checkbox>
                    </div>
                  </ng-container>
                  Actions
                </th>
                <th appColumnResizable *ngIf="show_ai_recommendations">AI Recommendation</th>
                <ng-container *ngFor="let column of table_columns">
                  <th appColumnResizable *ngIf="column.checked">{{ column.name }}</th>
                </ng-container>
              </tr>
            </thead>
            <ng-container *ngIf="table_data_loaded">
              <tbody *ngIf="table_data.length > 0">
                <ng-container
                  *ngFor="
                    let client of table_data
                      | paginate
                        : {
                            id: 'prospects-data',
                            itemsPerPage: pagination_records_limit,
                            currentPage: current_pagination_page,
                            totalItems: total_pagination_records
                          };
                    let clientIndex = index
                  "
                >
                  <tr>
                    <!-- <td>
                              <mat-checkbox [checked]="checkIndividualSelection(client)" (change)="selectIndividual($event, client)"></mat-checkbox>
                              </td> -->
                    <!-- <td>
                              <mat-checkbox [checked]="checkIndividualSelection(client)" (change)="selectIndividual($event, client)"></mat-checkbox>
                              </td> -->
                    <td>
                      <ng-container *ngIf="page_type != 'Individual'">
                        <div class="record-selection-section" *ngIf="!user_details.is_book_optimized">
                          <mat-checkbox [checked]="checkIndividualSelection(client)" (change)="selectIndividual($event, client)"></mat-checkbox>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="page_type == 'Individual'">
                        <div class="record-selection-section">
                          <mat-checkbox [checked]="checkIndividualSelection(client)" (change)="selectIndividual($event, client)"></mat-checkbox>
                        </div>
                      </ng-container>
                      <!-- <img
                        src="assets/view-tasks.png"
                        class="client-table-icon"
                        (click)="openClientDataModal(client)"
                      /> -->
                      <img
                        src="assets/view-tasks.png"
                        class="client-table-icon"
                        (click)="showUserProfile(client)"
                      />
                    </td>
                    <td
                      *ngIf="show_ai_recommendations"
                      class="highlight-table-cell"
                    >
                      {{ client.ai_recommendation }}
                    </td>
                    <ng-container
                      *ngFor="let column of table_columns"
                      [ngSwitch]="column.key"
                    >
                      <ng-container *ngSwitchCase="'status'">
                        <td *ngIf="column.checked">
                          <p class="status-tag completed-status">
                            {{ client.status }}
                          </p>
                        </td>
                      </ng-container>
                      <ng-container *ngSwitchCase="'recommendation'">
                        <ng-container *ngIf="page_type != 'Individual'">
                          <ng-container *ngIf="!user_details.is_book_optimized">
                            <td class="highlight-table-cell" *ngIf="column.checked">
                              <!-- {{ getKey(client, column) }} -->
                              <mat-select class="page-modal-input" [(ngModel)]="client.recommendation" (selectionChange)="saveIndiviualRecommendation(client)">
                                <mat-option [value]="'Increase Focus'">Increase Focus</mat-option>
                                <!-- <mat-option [value]="'Delegate MAGI'">Delegate MAGI</mat-option> -->
                                <mat-option [value]="'MAGI'">MAGI</mat-option>
                                <!-- <mat-option [value]="'Delegate AFA'">Delegate AFA</mat-option> -->
                                <mat-option [value]="'Junior Advisor'">Junior Advisor</mat-option>
                                <!-- <mat-option [value]="'Remove Recommendation'">Remove Recommendation</mat-option> -->
                              </mat-select>
                            </td>
                          </ng-container>
                          <ng-container *ngIf="user_details.is_book_optimized">
                            <td class="highlight-table-cell" *ngIf="column.checked">
                              {{ getKey(client, column) }}
                            </td>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="page_type == 'Individual'">
                          <ng-container>
                            <td class="highlight-table-cell" *ngIf="column.checked">
                              {{ getKey(client, column) }}
                            </td>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchCase="'assigned_agi'">
                        <ng-container *ngIf="page_type != 'Individual'">
                          <ng-container *ngIf="!user_details.is_book_optimized">
                            <td class="highlight-table-cell" *ngIf="column.checked">
                              <mat-select class="page-modal-input" [(ngModel)]="client.assigned_agi" (selectionChange)="saveIndiviualAssignMAGI(client)">
                                <mat-option [value]="true">Yes</mat-option>
                                <mat-option [value]="false">No</mat-option>
                              </mat-select>
                            </td>
                          </ng-container>
                          <ng-container *ngIf="user_details.is_book_optimized">
                            <td class="highlight-table-cell" *ngIf="column.checked">
                              <span *ngIf="client.assigned_agi">Yes</span>
                              <span *ngIf="!client.assigned_agi">No</span>
                            </td>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="page_type == 'Individual'">
                          <ng-container>
                            <td class="highlight-table-cell" *ngIf="column.checked">
                              {{ getKey(client, column) }}
                            </td>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchCase="'assigned_junior_advisor'">
                        <ng-container *ngIf="page_type != 'Individual'">
                          <ng-container *ngIf="!user_details.is_book_optimized">
                            <td class="highlight-table-cell" *ngIf="column.checked">
                              <mat-select class="page-modal-input" [(ngModel)]="client.assigned_junior_advisor" (selectionChange)="saveIndiviualAssignAFA(client)">
                                <mat-option [value]="''">None</mat-option>
                                <mat-option *ngFor="let afa of afa_list" [value]="afa.id">{{afa.first_name}} {{afa.last_name}}</mat-option>
                              </mat-select>
                            </td>
                          </ng-container>
                          <ng-container *ngIf="user_details.is_book_optimized">
                            <td class="highlight-table-cell" *ngIf="column.checked">
                              {{client.assigned_junior_advisor_name }}
                            </td>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="page_type == 'Individual'">
                          <ng-container>
                            <td class="highlight-table-cell" *ngIf="column.checked">
                              {{ getKey(client, column) }}
                            </td>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchCase="'ai_rank'">
                        <td class="highlight-table-cell" *ngIf="column.checked">
                          {{ getKey(client, column) }}
                        </td>
                      </ng-container>
                      <ng-container *ngSwitchCase="'opportunity'">
                        <td class="highlight-table-cell" *ngIf="column.checked">
                          {{ getKey(client, column) }}
                        </td>
                      </ng-container>
                      <ng-container
                        *ngSwitchCase="'predicted_wallet_share_growth'"
                      >
                        <td class="highlight-table-cell" *ngIf="column.checked">
                          {{ getKey(client, column) }}
                        </td>
                      </ng-container>
                      <ng-container *ngSwitchCase="'predicted_closure_days'">
                        <td class="highlight-table-cell" *ngIf="column.checked">
                          {{ getKey(client, column) }} Day(s)
                        </td>
                      </ng-container>
                      <ng-container *ngSwitchCase="'recommended_products'">
                        <td class="highlight-table-cell" *ngIf="column.checked" [matTooltip]="getKey(client, column)">
                          {{ getKey(client, column) }}
                        </td>
                      </ng-container>

                      <ng-container *ngSwitchCase="'preferred_channel'">
                        <td class="highlight-table-cell" *ngIf="column.checked" [matTooltip]="getKey(client, column)">
                          {{ getKey(client, column) }}
                        </td>
                      </ng-container>

                      <ng-container *ngSwitchCase="'actions'">
                        <td *ngIf="column.checked">
                          <img
                            src="assets/view-tasks.png"
                            class="client-table-icon"
                            (click)="openClientDataModal(client)"
                          />
                        </td>
                      </ng-container>
                      <ng-container *ngSwitchCase="'trigger'">
                        <td *ngIf="column.checked">
                          <span [style.color]="client['trigger_type'] == 'AI' ? '#f3a638' : '#4cb64c'">{{ getKey(client, column) }}</span>
                        </td>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <td *ngIf="column.checked">
                          {{ getKey(client, column) }}
                        </td>
                      </ng-container>
                    </ng-container>
                  </tr>
                </ng-container>
              </tbody>
              <tbody *ngIf="table_data.length == 0">
                <td colspan="15">
                  <div class="zero-state-section">
                    <span>No Data Found</span>
                  </div>
                </td>
              </tbody>
            </ng-container>
            <ng-container *ngIf="!table_data_loaded">
              <tbody>
                <tr>
                  <td
                    colspan="15"
                    class="zero-state-section"
                    style="height: 120px"
                  >
                    <!-- <ngx-spinner bdColor = "transparent" size = "medium" color = "#1B82EC" type = "ball-running-dots" [fullScreen] = "false"><p class="loading-state-text"> Loading... </p></ngx-spinner> -->
                    <app-loader
                      [loading_text]="'Loading'"
                    ></app-loader>
                  </td>
                </tr>
              </tbody>
            </ng-container>
          </table>
        </div>
        <!-- <div class="new-pagination-section"> -->
        <div class="new-table-v2-pagination-section">
          <span class="mx-4">{{ total_pagination_records | number:'1.0-0' }} Records</span>
          <mat-select
            class="pagination-input"
            [(ngModel)]="pagination_records_limit"
            (selectionChange)="current_pagination_page = 1; getClientsData()"
          >
            <mat-option [value]="10">10</mat-option>
            <mat-option [value]="100">100</mat-option>
            <mat-option [value]="500">500</mat-option>
            <mat-option [value]="1000">1000</mat-option>
          </mat-select>
          <!-- <div class="new-pagination-controls"> -->
          <div class="new-table-v2-pagination-controls">
            <pagination-controls
              id="prospects-data"
              (pageChange)="pageChanged($event)"
              style="text-align: right; position: relative; top: 6px"
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!page_loaded">
    <!-- <div class="ring">
      Loading
      <span></span>
      </div> -->
    <app-loader [loading_text]="'Loading Recommendations'"></app-loader>
  </div>

  <ng-template #clientDataModal>
    <div class="modal-section client-details-modal">
      <div class="modal-heading-section client-view-heading-section">
        <span class="modal-heading">Know Your Client</span>
        <span class="client-modal-icon" (click)="closeClientDataModal()"
          >&times;</span
        >
      </div>
      <div class="modal-content-section" *ngIf="!selected_modal_client_loader">
        <app-client-profile [client_data]="selected_client"></app-client-profile>
      </div>
      <div class="modal-content-section" *ngIf="selected_modal_client_loader">
          <app-loader [loading_text]="'Loading Client Profile'"></app-loader>
      </div>
    </div>
  </ng-template>

  <ng-template #assignAIAdvisorAssistantModal>
    <div class="page-modal-section">
      <div class="page-modal-heading-section">
        <span>Update Recommendation</span>
        <span
          class="page-modal-close-icon"
          (click)="closeAssignAIAdvisorAssistantModal()"
          >&times;</span
        >
      </div>
      <div class="page-modal-content-section">
        <div class="page-modal-input-section">
          <p class="page-modal-input-label">Select</p>
          <mat-select class="page-modal-input" [(ngModel)]="ai_advisor_assistant">
            <mat-option [value]="'Increase Focus'">Increase Focus</mat-option>
            <!-- <mat-option [value]="'Delegate MAGI'">Delegate MAGI</mat-option> -->
            <mat-option [value]="'MAGI'">MAGI</mat-option>
            <!-- <mat-option [value]="'Delegate AFA'">Delegate AFA</mat-option> -->
            <mat-option [value]="'Junior Advisor'">Junior Advisor</mat-option>
            <!-- <mat-option [value]="'Remove Recommendation'">Remove Recommendation</mat-option> -->
          </mat-select>
          <p class="page-modal-input-error" *ngIf="ai_advisor_assistant_error">
            Select Recommendation to update.
          </p>
        </div>
      </div>
      <div class="page-modal-footer-section">
        <button
          class="page-modal-primary-button"
          *ngIf="!assigning_ai_advisor_assistant_loader"
          (click)="assignAIAdvisorAssistant()"
        >
          Save
        </button>
        <button
          class="page-modal-primary-button"
          *ngIf="assigning_ai_advisor_assistant_loader"
        >
          Saving ...
        </button>
        <button
          class="page-modal-secondary-button"
          (click)="closeAssignAIAdvisorAssistantModal()"
        >
          Cancel
        </button>
      </div>
    </div>
  </ng-template>

  <ng-container *ngIf="show_user_profile">
    <app-customer-profile [data]="user_profile_data" [client_type]="'Client'" (profileClosed)="profileClosed($event)"></app-customer-profile>
  </ng-container>

  <ng-template #delegateMAGIModal>
    <div class="page-modal-section">
      <div class="page-modal-heading-section">
        <span>Assign MAGI</span>
        <span
          class="page-modal-close-icon"
          (click)="closeDelegateMAGIModal()"
          >&times;</span
        >
      </div>
      <div class="page-modal-content-section">
        <p class="page-modal-delete-description">Are you sure you want to assign?</p>
      </div>
      <div class="page-modal-footer-section">
        <button
          class="page-modal-primary-button"
          *ngIf="!agi_assignment_loader"
          (click)="assignMAGI()"
        >
          Yes
        </button>
        <button
          class="page-modal-primary-button"
          *ngIf="agi_assignment_loader"
        >
          Assigning ...
        </button>
        <button
          class="page-modal-secondary-button"
          (click)="closeDelegateMAGIModal()"
        >
          No
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #delegateAFAModal>
    <div class="page-modal-section">
      <div class="page-modal-heading-section">
        <span>Assign Junior Advisor</span>
        <span
          class="page-modal-close-icon"
          (click)="closeDelegateAFAModal()"
          >&times;</span
        >
      </div>
      <div class="page-modal-content-section">
        <div class="page-modal-input-section">
          <p class="page-modal-input-label">Select</p>
          <mat-select class="page-modal-input" [(ngModel)]="junior_advisor">
            <mat-option [value]="''">None</mat-option>
            <mat-option *ngFor="let afa of afa_list" [value]="afa.id">{{afa.first_name}} {{afa.last_name}}</mat-option>
          </mat-select>
          <p class="page-modal-input-error" *ngIf="junior_advisor_assignment_error">
            Select Junior Advisor to assign.
          </p>
        </div>
      </div>
      <div class="page-modal-footer-section">
        <button
          class="page-modal-primary-button"
          *ngIf="!junior_advisor_assignment_loader"
          (click)="assignAFA()"
        >
          Save
        </button>
        <button
          class="page-modal-primary-button"
          *ngIf="junior_advisor_assignment_loader"
        >
          Saving ...
        </button>
        <button
          class="page-modal-secondary-button"
          (click)="closeDelegateAFAModal()"
        >
          Cancel
        </button>
      </div>
    </div>
  </ng-template>
